// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Nj8o","clinicsSelect":"styles_clinicsSelect__3odWI"};